"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TblBody = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const TblBody = (_a) => {
    var { children, className } = _a, rest = (0, tslib_1.__rest)(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, rest, { className: (0, lib_1.classnames)('tbl__body', className) }, { children: children }), void 0));
};
exports.TblBody = TblBody;
//# sourceMappingURL=TblBody.js.map